<div class="login-checkout-container">
  <div class="content" *ngIf="user$ | async as user">
    <div class="center">
      <kion-headline-tag [title]="component.headline" [titleSize]="component.titleSize" *ngIf="!user.user; else greeting"></kion-headline-tag>
      <ng-template #greeting>
        <kion-headline-tag [title]="'checkout.steps.login.greeting' | translate: {userName: userName$ | async}"></kion-headline-tag>
      </ng-template>
      <markdown class="description-text" [data]="component.content" *ngIf="!user.user"></markdown>
      <div class="action">
        <ng-container *ngIf="!user.user; else authenticated">
          <kion-button mode="primary" [title]="'checkout.spread.button.signIn' | translate" link="/auth" [isLink]="true"></kion-button>
          <kion-button mode="primary" [title]="'checkout.spread.button.signUp' | translate" link="/auth" [isLink]="true"></kion-button>
          <kion-button *ngIf="this.guestCheckoutEnabled$ | async" mode="discreet"
                       [title]="'checkout.spread.button.asGuest' | translate"
                       [link]="checkoutStepFirstRoute" [isLink]="true"></kion-button>
        </ng-container>
        <ng-template #authenticated>
          <kion-button mode="primary" [title]="'checkout.spread.button.continue' | translate" [link]="checkoutStepFirstRoute" [isLink]="true"></kion-button>
        </ng-template>
      </div>
      <div class="navigation">
        <kion-label-button [title]="'checkout.spread.button.backToBasket' | translate" [link]="basketRoute">
          <svg img-link xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path fill="#9B9B9E" fill-rule="evenodd" d="M14.286 4.571L2.522 4.571 6.118 0.975 5.31 0.167 0.335 5.143 5.31 10.118 6.118 9.31 2.522 5.714 14.286 5.714z" transform="translate(.571 2.857)"></path>
          </svg>
        </kion-label-button>
      </div>
    </div>
  </div>
</div>
